import React, { useState, useEffect } from "react";
import { filter } from "lodash";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import {
  Grid,
  Box,
  Typography,
  Divider,
  Modal,
  FormControl,
  TextField,
  Card,
  Table,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  TableContainer,
  TablePagination,
  Tooltip,
} from "@mui/material";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import EmailIcon from "@mui/icons-material/Email";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import { useDispatch, useSelector } from "react-redux";
import Page from "../components/Page";
import Label from "../components/Label";
import Scrollbar from "../components/Scrollbar";
import Iconify from "../components/Iconify";
import { UserListHead, UserListToolbar } from "../sections/@dashboard/user";
import {
  GetUserVendorListAction,
  CreateVendorProfileAction,
} from "../redux/actions/UsersAction";
import HeaderBreadcrumbs from "../components/HeaderBreadcrumbs";
import { CreditCardOff, PhoneDisabledOutlined } from "@mui/icons-material";
import { useSearchParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { setDate } from "date-fns";
import { toast } from "react-toastify";
import { baseUrlPostGres } from "src/redux/constant";
import moment from "moment"; // material
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { UpdateVendorStatusAction } from "../redux/actions/UsersAction";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "600px",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "15px",
};

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

export default function UserVendor() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const UserList = useSelector((state) => state.users.uservendor_list.data);
  const USERLIST = UserList !== undefined && UserList.data.users;

  const createVendorDetails = useSelector(
    (state) => state.users.create_vendor_details
  );
  const updateVendorList = useSelector(
    (state) => state.users.update_vendor_list
  );

  //console.log(createvendorDetails, "createvendorDetails");

  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState("name");
  const [filterName, setFilterName] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [showUser, setShowUser] = useState({});
  const [userType, setUserType] = useState([]);
  const search = useLocation().search;
  const queryParams = new URLSearchParams(search);
  const [state, setState] = useState({
    userList: [],
    v: {},
  });
  const [vendor, setVendor] = useState({
    name: "",
    phone: "",
    email: "",
    balance_api: "",
    wallet_check_api: "",
    deposit_api: "",
    apikeyofvendor: "",
    cricket: false,
    football: false,
    player_accumulator: false,
    player_contest: false,
  });
  const [open, setOpen] = useState(false);
  const [openNewV, setOpenNewV] = useState(false);
  const [userData, setUserData] = useState({});
  const [uploadedImage, setUploadedImage] = useState(null);
  // const [reFreshPage, setRefreshPage] = useState(false);
  // const [logoFile, setLogoFile] = useState(null);

  const [errors, setErrors] = useState({
    cricket: "",
    football: "",
    player_accumulator: "",
    player_contest: "",
    name: "",
    phone: "",
    email: "",
    balance_api: "",
    wallet_check_api: "",
    deposit_api: "",
    //apikeyofvendor: "",
    logoFileError: "",
  });

  useEffect(() => {
    if (UserList !== undefined) {
      setState({ ...state, userList: UserList.data.users });
    }
  }, [UserList, dispatch, updateVendorList]);

  let Typ = 1;
  if (queryParams.get("type") == 2) {
    Typ = 2;
  }
  useEffect(() => {
    dispatch(GetUserVendorListAction(page + 1, rowsPerPage, Typ));
  }, [dispatch, page, Typ, updateVendorList]);

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
  };

  const applySortFilter = (array, comparator, query) => {
    const stabilizedThis = array && array.map((el, index) => [el, index]);
    if (stabilizedThis) {
      stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
      });
    }
    if (query) {
      return filter(
        array,
        (_user) =>
          _user.user_profile?.name
            ?.toLowerCase()
            .indexOf(query.toLowerCase()) !== -1
      );
    }
    const filterData = stabilizedThis && stabilizedThis.map((el) => el[0]);
    return filterData;
  };

  const filteredUsers = applySortFilter(
    USERLIST,
    getComparator(order, orderBy),
    filterName
  );

  const handleFilter = (key, value) => {
    state[key] = value;
    setState({ ...state });
  };
  const handleFilterSubmit = (e) => {
    e.preventDefault();
    dispatch(GetUserVendorListAction(page + 1, rowsPerPage, Typ, state));
  };

  const handleResetFilter = () => {
    dispatch(GetUserVendorListAction(page + 1, rowsPerPage, Typ, {}));
    setState({
      name: "",
      phone: "",
      email: "",
      wallet_check_api: "",
      deposit_api: "",
      balance_api: "",
      apikeyofvendor: "",
      player_image: "",
    });
  };

  const handleNewVendorFilter = (key, value) => {
    vendor[key] = value;
    setVendor({ ...vendor });
  };

  // const handleNewVendor = (e) => {
  //   e.preventDefault();
  //   let formData = new FormData();
  //   if (vendor.id) {
  //     formData.append("id", vendor.id);
  //   }
  //   formData.append("name", vendor.name);
  //   formData.append("phone", vendor.phone);
  //   formData.append("email", vendor.email);
  //   formData.append("wallet_check_api", vendor.wallet_check_api);
  //   formData.append("deposit_api", vendor.deposit_api);
  //   formData.append("balance_api", vendor.balance_api);
  //   formData.append("apikeyofvendor", vendor.apikeyofvendor);
  //   formData.append(
  //     "player_accumulator",
  //     vendor.player_accumulator ? "1" : "0"
  //   );
  //   formData.append("player_contest", vendor.player_contest ? "1" : "0");
  //   formData.append("cricket", vendor.cricket ? "1" : "0");
  //   formData.append("football", vendor.football ? "1" : "0");

  //   if (uploadedImage) {
  //     formData.append("logo_url", uploadedImage);
  //   }
  //   //////
  //   console.log(formData, "formDataVendor");

  //   dispatch(CreateVendorProfileAction(formData));
  //   // setRefreshPage(true);
  //   setVendor({
  //     name: "",
  //     phone: "",
  //     email: "",
  //     wallet_check_api: "",
  //     deposit_api: "",
  //     balance_api: "",
  //     apikeyofvendor: "",
  //     player_image: "",
  //     player_accumulator: "",
  //     player_contest: "",
  //     cricket: "",
  //     football: "",
  //   });
  //   setUploadedImage(null);
  //   setOpenNewV(false);
  //   window.location.href = "/dashboard/uservendor/list";
  // };
  const handleNewVendor = (e) => {
    e.preventDefault();
    if (validateForm()) {
      const formData = new FormData();
      if (vendor.id) {
        formData.append("id", vendor.id);
      }
      formData.append("name", vendor.name);
      formData.append("phone", vendor.phone);
      formData.append("email", vendor.email);
      formData.append("wallet_check_api", vendor.wallet_check_api);
      formData.append("deposit_api", vendor.deposit_api);
      formData.append("balance_api", vendor.balance_api);
      formData.append("apikeyofvendor", vendor.apikeyofvendor);
      formData.append(
        "player_accumulator",
        vendor.player_accumulator ? "1" : "0"
      );
      formData.append("player_contest", vendor.player_contest ? "1" : "0");
      formData.append("cricket", vendor.cricket ? "1" : "0");
      formData.append("football", vendor.football ? "1" : "0");

      if (uploadedImage) {
        formData.append("logo_url", uploadedImage);
      } else {
        formData.append("logo_url", vendor.logo_url);
      }
      // if (uploadedImage) {
      //   formData.append("logo_url", uploadedImage);
      // }

      // Submit formData or dispatch action here

      dispatch(CreateVendorProfileAction(formData));

      // Clear form and close modal after submission
      setVendor({
        name: "",
        phone: "",
        email: "",
        wallet_check_api: "",
        deposit_api: "",
        balance_api: "",
        apikeyofvendor: "",
        player_image: "",
        player_accumulator: "",
        player_contest: "",
        cricket: "",
        football: "",
        logo_url: "",
      });
      //setLogoFile(null);
      setUploadedImage(null);
      setOpenNewV(false); // Close the modal after successful submission
      // window.location.href = "/dashboard/uservendor/list"; // Redirect or handle navigation
    } else {
      console.log("Form contains errors. Please correct them.");
    }
  };

  const ViewDetails = (userid) => {
    USERLIST?.find((elem) => {
      if (elem.id === userid) {
        setShowUser(elem);
        // window.open(navigate(`/dashboard/user-details/${userid}`, { state: elem }), '_blank');
        window.open(`/dashboard/user-details/${userid}`, "_blank");
      }
    });
  };

  const handleOpen = (data) => {
    setOpen(true);
    setUserData(data);
  };

  const handleOpenEdit = (data) => {
    setOpenNewV(true);
    setVendor(data);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleNewVOpen = (data) => {
    setOpenNewV(true);
    setUserData(data);
  };
  const handleNewVClose = () => {
    setOpenNewV(false);
  };

  const PhoneNo = {
    8107357227: "8107458227",
    9162921397: "9168545597",
  };

  const handleChange = (e) => {
    const { files } = e.target;
    if (files?.length > 0) {
      const { name, type } = files[0];
      const params = {
        key: name.includes(".") ? name.substring(0, name.indexOf(".")) : name,
        extension: type.includes("/")
          ? type.substring(type.indexOf("/") + 1)
          : type,
      };

      if (
        params.extension.toLowerCase() === "jpg" ||
        params.extension.toLowerCase() === "jpeg" ||
        params.extension.toLowerCase() === "png" ||
        params.extension.toLowerCase() === "svg"
      ) {
        if (files) {
          const reader = new FileReader();
          reader.onload = function (e) {
            document.getElementById("profileImg").src = e.target.result;
          };
          reader.readAsDataURL(e.target.files[0]);
          setUploadedImage(e.target.files[0]);
        }
        toast.success("Image Uploaded Successfully", { theme: "colored" });
      } else {
        toast.error(
          "Only image with .jpeg, .jpg, .png, .svg extentions are valid."
        );
      }
    }
  };

  const validateForm = () => {
    let valid = true;
    const newErrors = {
      cricket: "",
      football: "",
      player_accumulator: "",
      player_contest: "",
      name: "",
      phone: "",
      email: "",
      balance_api: "",
      wallet_check_api: "",
      deposit_api: "",
      // apikeyofvendor: "",
    };

    // Validate checkboxes
    if (!vendor.cricket && !vendor.football) {
      newErrors.cricket = "Select at least one sport (Cricket or Football)";
      newErrors.football = "Select at least one sport (Cricket or Football)";
      valid = false;
    }
    if (!vendor.player_accumulator && !vendor.player_contest) {
      newErrors.player_accumulator =
        "Select at least one Games (Player Accumulator or Player Contest)";
      newErrors.player_contest =
        "Select at least one Games (Player Accumulator or Player Contest)";
      valid = false;
    }

    // if (!vendor.player_accumulator) {
    //   newErrors.player_accumulator = "Player Accumulator is required";
    //   valid = false;
    // }

    // if (!vendor.player_contest) {
    //   newErrors.player_contest = "Player Contest is required";
    //   valid = false;
    // }

    // Validate text fields
    if (!vendor.name.trim()) {
      newErrors.name = "Company Name is required";
      valid = false;
    }
    if (!vendor.phone.trim()) {
      newErrors.phone = "Phone is required";
      valid = false;
    }
    if (!vendor.email.trim()) {
      newErrors.email = "Email is required";
      valid = false;
    }

    // Validate logo file
    if (!uploadedImage && !vendor.logo_url) {
      newErrors.logoFileError = "Company Logo is required";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (updateVendorList) {
          console.log("Message:", createVendorDetails?.data?.message);
          const message =
            createVendorDetails?.data?.message || "Message unavailable";
          toast.success(message, { theme: "colored" });

          setTimeout(() => {
            window.location.reload();
          }, 500);
        }
      } catch (error) {
        console.error("Error in useEffect:", error);
        toast.error("Error fetching data", { theme: "colored" });
      }
    };

    fetchData();
  }, [updateVendorList]); // Depend on UserVendorList directly, not UserVendorList?.data?.status

  //for status
 const handleToggleStatus = (user) => {
  const updatedStatus = user.status === 1 ? 0 : 1;
  const updateData = {
    vendorId: user.id,
    status: updatedStatus,
    cricket: updatedStatus,
    football: updatedStatus,
    player_accumulator: updatedStatus,
    player_contest: updatedStatus,
  };
  console.log("Final payload being sent:", updateData);
  dispatch(UpdateVendorStatusAction(updateData, () => {
    dispatch(GetUserVendorListAction(page + 1, rowsPerPage, Typ));
  }));
};


  return (
    <Page title="User">
      <Container maxWidth="lg">
        <HeaderBreadcrumbs
          heading="User List"
          links={[
            { name: "Dashboard", href: "/dashboard/app" },
            { name: "Users" },
          ]}
        />
        <Card>
          {/* <UserListToolbar
                        numSelected={selected.length}
                        filterName={filterName}
                        onFilterName={handleFilterByName}
                        placeholder="Search user..."
                    /> */}
          <Scrollbar style={{ maxHeight: "500px", overflowY: "auto" }}>
            <TableContainer sx={{ minWidth: 800 }}>
              <form autoComplete="off" onSubmit={handleFilterSubmit}>
                <Grid
                  container
                  spacing={2}
                  style={{ marginBottom: 10, marginTop: 2 }}
                >
                  <Grid item md={3}>
                    <FormControl fullWidth>
                      <TextField
                        onChange={({ target }) =>
                          handleFilter("phone", target.value)
                        }
                        type="number"
                        label="Phone"
                        variant="outlined"
                        value={state.phone}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item md={3}>
                    <FormControl fullWidth>
                      <TextField
                        onChange={({ target }) =>
                          handleFilter("email", target.value)
                        }
                        type="email"
                        label="Email"
                        variant="outlined"
                        value={state.email}
                      />
                    </FormControl>
                  </Grid>
                  <Grid
                    item
                    md={3}
                    style={{
                      textAlign: "left",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <div className="reset-filter">
                      <Button
                        size="large"
                        color="primary"
                        className="btn"
                        variant="contained"
                        type="submit"
                      >
                        Search
                      </Button>
                    </div>

                    <div className="reset-filter">
                      <Button
                        color="primary"
                        className="btn"
                        onClick={handleResetFilter}
                      >
                        Reset Filter
                      </Button>
                    </div>
                    <div className="reset-filter">
                      <Button
                        size="large"
                        color="primary"
                        className="btn"
                        variant="contained"
                        type="submit"
                        onClick={handleNewVOpen}
                      >
                        New Vendor
                      </Button>
                    </div>
                  </Grid>
                </Grid>
              </form>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={[
                    { id: "c_no", label: "Sr no.", alignRight: false },
                    { id: "name", label: "Name", alignRight: false },
                    { id: "email", label: "Email Address", alignRight: false },
                    { id: "cricket", label: "Cricket", alignRight: false },
                    { id: "football", label: "football", alignRight: false },
                    {
                      id: "player_accumulator",
                      label: "Accumulator",
                      alignRight: false,
                    },
                    {
                      id: "player_contest",
                      label: "Contest",
                      alignRight: false,
                    },
                    {
                      id: "phoneNumber",
                      label: "Phone Number",
                      alignRight: false,
                    },
                    { id: "createdAt", label: "Registered", alignRight: false },
                    { id: "status", label: "Status", alignRight: false },
                    { id: "action", label: "Access Key", alignRight: false },
                    { id: "edit", label: "Edit", alignRight: false },
                  ]}
                  rowCount={UserList?.data?.total_count}
                  numSelected={selected?.length}
                  // onRequestSort={handleRequestSort}
                />
                <TableBody>
                  {filteredUsers &&
                    filteredUsers.map((data, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell component="th" scope="row">
                            {page * rowsPerPage + (index + 1)}.
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {data.name ? data.name : "-"}
                          </TableCell>
                          <TableCell align="left"> {data.email} </TableCell>
                          <TableCell align="left">
                            {" "}
                            {data.cricket === 1 ? (
                              <Label variant="ghost" color="success">
                                Active
                              </Label>
                            ) : (
                              <Label variant="ghost" color="error">
                                Inactive
                              </Label>
                            )}{" "}
                          </TableCell>
                          <TableCell align="left">
                            {" "}
                            {data.football === 1 ? (
                              <Label variant="ghost" color="success">
                                Active
                              </Label>
                            ) : (
                              <Label variant="ghost" color="error">
                                Inactive
                              </Label>
                            )}{" "}
                          </TableCell>
                          <TableCell align="left">
                            {" "}
                            {data.player_accumulator === 1 ? (
                              <Label variant="ghost" color="success">
                                Active
                              </Label>
                            ) : (
                              <Label variant="ghost" color="error">
                                Inactive
                              </Label>
                            )}
                          </TableCell>
                          <TableCell align="left">
                            {data.player_contest === 1 ? (
                              <Label variant="ghost" color="success">
                                Active
                              </Label>
                            ) : (
                              <Label variant="ghost" color="error">
                                Inactive
                              </Label>
                            )}
                          </TableCell>
                          <TableCell align="left">
                            {data.country_code} {data.phone}
                          </TableCell>
                          <TableCell align="left">
                            {moment(data.createdAt).format(
                              "YYYY/MM/DD,  h:mm:ss a"
                            )}
                          </TableCell>
                          {/* <TableCell align="left">
                            {data.status === 1 ? (
                              <Label variant="ghost" color="success">
                                Active
                              </Label>
                            ) : (
                              <Label variant="ghost" color="error">
                                Inactive
                              </Label>
                            )}
                          </TableCell> */}

                          <TableCell align="left">
                              <button
                              onClick={() =>{console.log("Button clicked", data); handleToggleStatus(data)}}
                              style={{
                                backgroundColor: data.status === 1 ? "#E6F4EA" : "#FDECEA", // light green or light red
                                color: data.status === 1 ? "#2E7D32" : "#C62828", // dark green or dark red
                                padding: "4px 12px",
                                fontSize: "14px",
                                borderRadius: "6px",
                                fontWeight: "500",
                                border: "1px solid",
                                borderColor: data.status === 1 ? "#A5D6A7" : "#F5C6CB", // green or red border
                                cursor: "pointer",
                              }}
                            >
                              {data.status === 1 ? "Active" : "Inactive"}
                            </button>
                            </TableCell>

                          <TableCell>
                            <Button onClick={() => handleOpen(data)}>
                              <Iconify
                                icon="eva:eye-fill"
                                width={24}
                                height={24}
                              />
                            </Button>
                          </TableCell>

                          <TableCell>
                            <Button onClick={() => handleOpenEdit(data)}>
                              <Iconify icon="uil:edit" width={24} height={24} />
                            </Button>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>
          <TablePagination
            rowsPerPageOptions={[25, 50, 100, 150, 200]}
            component="div"
            count={UserList?.data?.total_count}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>

        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          size="lg"
        >
          <Box sx={style}>
            <Typography
              id="modal-modal-title"
              style={{ marginBottom: 20 }}
              align={"center"}
              variant="h6"
              component="h2"
            >
              {" "}
              {userData.name}{" "}
            </Typography>
            <Divider />
            <TableContainer fullWidth>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      {" "}
                      Api Key{" "}
                    </TableCell>
                    <TableCell align="left">{userData.apikey} </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Modal>

        <Modal
          open={openNewV}
          onClose={handleNewVClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          size="lg"
        >
          <Box sx={style}>
            <Typography
              id="modal-modal-title"
              style={{ marginBottom: 20 }}
              align={"center"}
              variant="h6"
              component="h2"
            >
              {" "}
              New Vendor{" "}
            </Typography>
            <Divider />
            <form autoComplete="off" onSubmit={handleNewVendor}>
              <Grid
                container
                spacing={2}
                style={{
                  height: "400px",
                  overflowY: "auto",
                  marginBottom: 10,
                  marginTop: 1,
                }}
              >
                <Grid item xs={6}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={vendor?.cricket}
                        onChange={(event) =>
                          handleNewVendorFilter("cricket", event.target.checked)
                        }
                        name="cricket"
                        color="primary"
                      />
                    }
                    label="Cricket"
                  />
                  {errors.cricket && (
                    <Typography variant="body2" color="error">
                      {errors.cricket}
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={6}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={vendor?.football}
                        onChange={(event) =>
                          handleNewVendorFilter(
                            "football",
                            event.target.checked
                          )
                        }
                        name="football"
                        color="primary"
                      />
                    }
                    label="Football"
                  />
                  {errors.football && (
                    <Typography variant="body2" color="error">
                      {errors.football}
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={6}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={vendor.player_accumulator}
                        onChange={(event) =>
                          handleNewVendorFilter(
                            "player_accumulator",
                            event.target.checked
                          )
                        }
                        name="player_accumulator"
                        color="primary"
                      />
                    }
                    label="Player Accumulator"
                  />
                  {errors.player_accumulator && (
                    <Typography variant="body2" color="error">
                      {errors.player_accumulator}
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={6}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={vendor?.player_contest}
                        onChange={(event) =>
                          handleNewVendorFilter(
                            "player_contest",
                            event.target.checked
                          )
                        }
                        name="player_contest"
                        color="primary"
                      />
                    }
                    label="Player Contest"
                  />
                  {errors.player_contest && (
                    <Typography variant="body2" color="error">
                      {errors.player_contest}
                    </Typography>
                  )}
                </Grid>

                <Grid item md={6}>
                  <FormControl fullWidth>
                    <TextField
                      onChange={({ target }) =>
                        handleNewVendorFilter("name", target.value)
                      }
                      type="name"
                      label="Company Name"
                      variant="outlined"
                      value={vendor.name}
                    />
                    {errors.name && (
                      <Typography variant="body2" color="error">
                        {errors.name}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                <Grid item md={6}>
                  <FormControl fullWidth>
                    <TextField
                      onChange={({ target }) =>
                        handleNewVendorFilter("phone", target.value)
                      }
                      type="number"
                      label="Phone"
                      variant="outlined"
                      value={vendor.phone}
                    />
                    {errors.phone && (
                      <Typography variant="body2" color="error">
                        {errors.phone}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                <Grid item md={6}>
                  <FormControl fullWidth>
                    <TextField
                      onChange={({ target }) =>
                        handleNewVendorFilter("email", target.value)
                      }
                      type="email"
                      label="Email"
                      variant="outlined"
                      value={vendor.email}
                    />
                    {errors.email && (
                      <Typography variant="body2" color="error">
                        {errors.email}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                <Grid item md={6}>
                  <FormControl fullWidth>
                    <TextField
                      onChange={({ target }) =>
                        handleNewVendorFilter("balance_api", target.value)
                      }
                      type="balance_api"
                      label="Balance API"
                      variant="outlined"
                      value={vendor.balance_api}
                    />
                  </FormControl>
                </Grid>
                <Grid item md={6}>
                  <FormControl fullWidth>
                    <TextField
                      onChange={({ target }) =>
                        handleNewVendorFilter("wallet_check_api", target.value)
                      }
                      type="wallet_check_api"
                      label="Wallet Check API"
                      variant="outlined"
                      value={vendor.wallet_check_api}
                    />
                  </FormControl>
                </Grid>
                <Grid item md={6}>
                  <FormControl fullWidth>
                    <TextField
                      onChange={({ target }) =>
                        handleNewVendorFilter("deposit_api", target.value)
                      }
                      type="deposit_api"
                      label="Deposit API"
                      variant="outlined"
                      value={vendor.deposit_api}
                    />
                  </FormControl>
                </Grid>
                <Grid item md={6}>
                  <FormControl fullWidth>
                    <TextField
                      onChange={({ target }) =>
                        handleNewVendorFilter("apikeyofvendor", target.value)
                      }
                      type="apikeyofvendor"
                      label="API key of vendor"
                      variant="outlined"
                      value={vendor.apikeyofvendor}
                    />
                    {/* {errors.apikeyofvendor && (
                      <Typography variant="body2" color="error">
                        {errors.apikeyofvendor}
                      </Typography>
                    )} */}
                  </FormControl>
                </Grid>

                <Grid item xs={6} style={{ marginTop: 30, marginBottom: 20 }}>
                  <label
                    htmlFor="file-upload"
                    style={{
                      display: "inline-block",
                      padding: "10px 20px",
                      cursor: "pointer",
                      backgroundColor: "#EB6320", // Updated background color
                      color: "white",
                      border: "2px solid #EB6320", // Matching border color
                      borderRadius: "6px",
                      fontSize: "13px",
                      fontWeight: "bold",
                      textAlign: "center",
                      textTransform: "uppercase",
                      boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.4)",
                      background: "linear-gradient(145deg, #EB6320, #EB4E05)", // Updated gradient
                      transition:
                        "transform 0.2s, box-shadow 0.2s, background-color 0.2s", // Transition properties
                    }}
                    onMouseDown={(e) => {
                      e.currentTarget.style.transform = "translateY(2px)";
                      e.currentTarget.style.boxShadow =
                        "0px 5px 10px rgba(0, 0, 0, 0.5)";
                      e.currentTarget.style.backgroundColor = "#EB4E05"; // Darker shade on press
                    }}
                    onMouseUp={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow =
                        "0px 10px 20px rgba(0, 0, 0, 0.4)";
                      e.currentTarget.style.backgroundColor = "#EB6320"; // Return to original color on release
                    }}
                  >
                    Choose Logo
                  </label>
                  <input
                    id="file-upload"
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleChange(e)}
                    style={{ display: "none" }}
                  />

                  {errors.logoFileError && (
                    <Typography variant="body2" color="error">
                      {errors.logoFileError}
                    </Typography>
                  )}
                  {uploadedImage ? (
                    <img
                      src=""
                      id="profileImg"
                      className="img-fluid"
                      height="70"
                      style={{ marginTop: 10, borderRadius: "10px" }}
                      alt=""
                    />
                  ) : null}

                  {/* {vendor?.logo_url && (
                    <img
                      src={
                        baseUrlPostGres() + "/profile_doc/" + vendor.logo_url
                      }
                      className="img-fluid"
                      height="100"
                      style={{ marginTop: 10 }}
                      alt=""
                    />
                  )} */}
                  {!uploadedImage && vendor?.logo_url && (
                    <img
                      src={`${baseUrlPostGres()}/profile_doc/${
                        vendor.logo_url
                      }`}
                      className="img-fluid"
                      height="100"
                      style={{ marginTop: 10, borderRadius: "10px" }}
                      alt="Vendor Logo"
                      onError={(e) => {
                        e.target.onerror = null;
                        //e.target.src = "/path/to/default-image.jpg"; // Fallback image
                      }}
                    />
                  )}
                </Grid>
                <Grid
                  item
                  md={6}
                  style={{
                    textAlign: "left",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <div className="reset-filter">
                    <Button
                      size="large"
                      color="primary"
                      className="btn"
                      variant="contained"
                      type="submit"
                    >
                      Save
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </form>
          </Box>
        </Modal>
      </Container>
    </Page>
  );
}
